.txwnfr0 {
  display: flex;
  align-items: center;
  gap: var(--cp-spacing-xsmall);
  font: var(--cp-text-body-medium);
  color: var(--cp-action-color-branded-primary-enabled);
  text-decoration: none;
  white-space: nowrap;
  pointer-events: auto;
}
@media (min-width: 768px) {
  .txwnfr0 {
    display: none;
  }
}